// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Form from "./Form";
import Congrats from "./Congrats";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Form />} />
        <Route path="/congrats" element={<Congrats />} />
      </Routes>
    </Router>
  );
}

export default App;